type FeedbackConfig = {
	url?: string
	feedbacklanguages?: Record<string, string> | null
}

export const resolveFeedbackBaseUrl = (
	feedbackConfig: FeedbackConfig | null | undefined,
	language: unknown
): string => {
	const fallbackUrl = String(feedbackConfig?.url ?? '').trim()
	const urlsByLanguage = feedbackConfig?.feedbacklanguages
	const normalizedLanguage = String(language ?? '').trim().toLowerCase()
	const languageKey = normalizedLanguage.split(/[-_]/)[0] ?? normalizedLanguage

	if (urlsByLanguage && languageKey) {
		const localizedUrl = String(urlsByLanguage[languageKey] ?? '').trim()
		if (localizedUrl) {
			return localizedUrl
		}
	}

	return fallbackUrl
}

export const appendFeedbackContext = (
	baseUrl: string,
	context: {
		packageId?: unknown
		packageLng?: unknown
		sourceReqId?: unknown
		feedbackType?: unknown
	}
): string => {
	const url = String(baseUrl ?? '').trim()
	if (!url) {
		return ''
	}

	const params = new URLSearchParams()
	params.set('package', 'SAT')
	params.set('packageid', String(context.packageId ?? ''))
	params.set('packageLng', String(context.packageLng ?? ''))
	params.set('sourcereqid', String(context.sourceReqId ?? ''))
	params.set('feedbacktype', String(context.feedbackType ?? 'AJS'))

	const separator = url.includes('?') ? '&' : '?'
	return `${url}${separator}${params.toString()}`
}
